import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Icon } from 'react-spark';
import { offersSchema } from '../../offers-page-schemas';

import OffersTableRow from '../offers-table-row/OffersTableRow';
import Tooltip from '../../tooltip/Tooltip';
import stateSelectors from '../../redux/offer/state-selectors';

if (!OffersTableRow) {
    throw new Error('Cannot find OffersTableRow');
}
if (!Tooltip) {
    throw new Error('Cannot find Tooltip');
}

export class OffersTable extends Component {
    render() {
        const { sortedOffers } = this.props.offers;
        const { isSelectingOffer } = this.props;

        const offerRows = _.map(sortedOffers, (offer) => (
            <OffersTableRow
                offer={offer}
                key={offer.id}
                isSelectingOffer={isSelectingOffer}>
            </OffersTableRow>
        ));

        return (
            <Table
                variant="secondary"
                striped
                className="offers-table sprk-b-Table--spacing-medium"
            >
                <thead>
                    <tr>
                        <th></th>
                        <th>Loan Amount</th>
                        <th>Monthly Payment</th>
                        <th>Term</th>
                        <th>Interest Rate{' '}
                            <Tooltip
                                text="This rate is built into your monthly payment amount and stays the same through the life of your loan."
                            >
                                <Icon name="question" />
                            </Tooltip>
                        </th>
                        <th>APR</th>
                    </tr>
                </thead>
                <tbody>
                    {offerRows}
                </tbody>
            </Table>
        );
    }
}

OffersTable.propTypes = {
    offers: offersSchema.isRequired
};

const mapStateToProps = (state) => {
    const offerSelecting = stateSelectors.getOfferSelecting(state);
    return {
        isSelectingOffer: offerSelecting ? offerSelecting : false,
    };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OffersTable);
